import React from "react";
import HcsCaptionControl from "./hcs-captioncontrol";

/**
 * @class
 * @classdesc Toggle switch.
 *
 * @param {object} props - Control properties. See {@link HcsControl} for common properties.
 */
export default class HcsSwitch extends HcsCaptionControl {
    constructor(props) {
        super(props);

        this.valueChanged = this.valueChanged.bind(this);
    }

    valueChanged() {
        let self = this;

        const { data } = this.props;

        let isChecked = data.info.value === this.stateValue("on");
        let newValue = isChecked ? this.stateValue("off") : this.stateValue("on");

        this.props.checkValueChange(this, {
            confirmed: _ => {
                self.props.onConfig("setCfgValue", data.ident, newValue, {
                    sender: "HCS_SWITCH",
                    success: _ => {
                        super.triggerConfigurator();
                    }
                });
            }
        });
    }

    childClass() {
        const { data } = this.props;

        let classes = ["hcs-switch"];

        if(data.info.value === this.stateValue("on")) {
            classes.push("hcs-on");
        }

        return classes;
    }

	// override from base class
	getCcaoData() {
		const { data } = this.props;

		if(data.info.value !== "" ) {
			let value = data.values.find(value => {
				return value.ident === data.info.value;
			});

            if(value && value.data.CCAO_DATA) {
                try {
                    return JSON.parse(value.data.CCAO_DATA);
                } catch(e) {
                    console.error(`Error parsing CCAO_DATA object from ECS for attribute '${data.ident}' with value '${data.info.value}': ${e.message}: ${value.data.CCAO_DATA}`);
                }
            }
		}

		return null;
	}

    /**
     * Return ident value for on/off states.
     * The ECS object for this control always has an array of two state values.
     * @param {string} state - Desired state. Use either "on" or "off".
     * @returns {string} Ident value for desired state.
     */
    stateValue(state) {
        const { data } = this.props;

        if(data.values.length < 2) {
            console.error(`Switch control ${data.ident} does not contain any state values.`);
            return null;
        }

        switch(state) {
            case "off":
                return data.values[0].ident;

            case "on":
                return data.values[1].ident;

            default:
                console.error("Unsupported value for HcsSwitch.stateValue(): " + state);
                break;
        }
    }

    render() {
        const { data } = this.props;

        return super.render(
            <React.Fragment key={data.ident + "_" + data.info.value}>
                <div onClick={super.isEnabled() ? this.valueChanged : null}>
                    <div></div>
                </div>
            </React.Fragment>
        );
    }
}
